import * as React from 'react';
import classnames from 'classnames';

import Label from '@components/library/labels/PrimaryLabel';
import Input from '@components/library/inputs/PrimaryInput';
import { capitalize } from '@components/library/helper';

import { InputContainerProps } from './InputContainer.props';

import './base_styles.scss';
import { InputType, InputAttributes } from '../inputs/Input.props';

const defaultAttributeProps: Partial<InputAttributes> = {
  type: InputType.Text
};

const InputContainer = (props: InputContainerProps): JSX.Element => {
  const fullProps = {
    ...props,
    attributes: {
      ...defaultAttributeProps,
      ...props.attributes
    }
  };
  const {
    attributes,
    options,
    selectValue,
    children,
    input,
    labelCopy,
    submitAttempted,
    validationRules,
    className,
    id
  } = fullProps;
  const { error } = input;
  const inputId = attributes.id || attributes.name;

  return (
    <div
      className={classnames(
        'bf-input-container',
        { invalid: submitAttempted && error },
        className,
      )}
      id={id}
    >
      <Label
        attributes={{ htmlFor: inputId }}
      >
        {labelCopy || capitalize(attributes.name)}
      </Label>
      <Input
        attributes={attributes}
        input={input}
        submitAttempted={submitAttempted}
        validationRules={validationRules}
        options={options}
        selectValue={selectValue}
      />
      {children}
      <p className={classnames(
        'input-error',
        { active: submitAttempted && error }
      )}
      >
        {error}
      </p>
    </div>
  );
};

export default InputContainer;
